import Cart from '../../views/cart/Cart';
import Summary from '../../views/cart/Summary';

export default [
    {
        path: '/carrello',
        name: 'cart',
        component: Cart,
        meta: {showNav: true}
    },
    {
        path: '/carrello/riepilogo',
        name: 'cart.summary',
        component: Summary,
        meta: {showNav: true}
    },
]
